import { client } from "api";
import { Company } from "models/Company";
import { CompanyContact } from "models/CompanyContact";

export type CreateContactRequest = { companyId: Company["id"] } & Pick<CompanyContact, "name" | "email" | "phone">;

export type CreateContactResponse = CompanyContact[];

export const createContact = ({ companyId, name, email, phone }: CreateContactRequest) =>
  client.post<CreateContactResponse>(`/company/${companyId}/contacts`, { name, email, phone }).then((res) => res.data);
